import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator";
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator";


export class Stkle {
    @MaxLength(10,{message: 'COMPANY 字串太長'})
    @IsString({message: 'COMPANY 不是字串型態'})
    COMPANY: string = "";

    @MaxLength(10)
    CREATOR: string = "";

    @MaxLength(10)
    USR_GROUP: string = "";

    @MaxLength(8)
    CREATE_DATE: string ="";

    @MaxLength(10)
    MODIFIER: string = "";

    @MaxLength(8)
    MODI_DATE: string = "";

    @IsNumber()
    @Max(999)
    FLAG: number =0;


    @IsNotEmpty({message: '交易日期 (LE001) 不可空白'})
    @MaxLength(8,{message: '交易日期 (LE001) 資料太長'})
    LE001: string = '';            // 交易日期 8 STKMJ STKMM 寫入

    @IsNotEmpty({message: '時間 (LE002) 不可空白'})
    @MaxLength(8,{message: '時間 (LE002) 資料太長'})
    LE002: string = '';            // 時間 8

    @MaxLength(10,{message: '股票代號 (LE003) 資料太長'})
    LE003: string = '';            // 股票代號 10

    @MaxLength(20,{message: '條件名稱 (LE004) 資料太長'})
    LE004: string = '';            // 條件名稱 20 STK.MJ003 OR TM031~TM038

    @MaxLength(1,{message: '流程碼 (LE005) 資料太長'})
    LE005: string = '1';            // 流程碼 1 [DEF:"1"] 1.買進 2.賣出  量價齊揚

    @MaxLength(10,{message: '股票名稱 (LE006) 資料太長'})
    LE006: string = '';            // 股票名稱 10

    @MaxLength(200,{message: '內容 (LE007) 資料太長'})
    LE007: string = '';            // 內容 200

    @MaxLength(1,{message: '已讀 (LE008) 資料太長'})
    LE008: string = 'N';            // 已讀 1 [DEF:"N"]

    @MaxLength(1,{message: '已傳 (LE009) 資料太長'})
    LE009: string = 'N';            // 已傳 1 [DEF:"N"]

    @MaxLength(6,{message: '條件代號 (LE010) 資料太長'})
    LE010: string = '';            // 條件代號 6 STKMJ.MJ002  ZNDX 類股統計 TM???

    @IsNotEmpty({message: '序號 (LE011) 不可空白'})
    @MaxLength(4,{message: '序號 (LE011) 資料太長'})
    LE011: string = '';            // 序號 4

    @IsNumber()
    LE012: number = 0;            // 已說次數 2 [DEF:0]

    @IsNumber()
    LE013: number = 0;            // 價格 11.2


}
